(function(){
    var wrapper = document.querySelector('.bearytales-wrapper')
    var iframe = document.querySelector('#bearytales')
    var img = document.querySelector('.bearytales-cover')

    function getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    if(location.search.includes('story')){
        var story = getParameterByName('story')
        iframe.src = 'https://napperhood.com/bearytales?day={{- day -}}&story=' + story
        wrapper.style.transition = 'none';
        wrapper.classList.add('active');
        wrapper.style.transition = '';
    }

    img.addEventListener('click', function(){
        wrapper.classList.add('active')
        document.body.classList.add('overflow-hidden')
    })


    document.querySelector('#main-bearytales .large-block button').addEventListener('click', function(){
        wrapper.classList.add('active')
        document.body.classList.add('overflow-hidden')
    })

    document.querySelector('.bearytales-wrapper span').addEventListener('click', function(){
        wrapper.classList.remove('active')
        document.body.classList.remove('overflow-hidden')
    })
})()